<div class="settings w-100-p" fxLayout="column"
     fxFlex
     cdkDropListGroup
     data-test="C-Kontaktdaten">

    <div class="fuse-card auto-width">

        <div class="nav-editor-header p-16"
             fxLayout="column" fxLayoutAlign="center stretch"
             fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

            <div fxLayout="row" fxLayoutAlign="start center">

                <div fxLayout="column" fxLayoutAlign="start start">
                    <div class="h2 mb-16">
                        {{ 'userSettings.navigation.editorTitle' | translate }}
                    </div>
                    <div class="subtitle secondary-text" style="width: 60%">
                        {{ 'userSettings.navigation.editorIntro' | translate }}
                    </div>
                </div>

            </div>

            <ng-template #saving>
                <mat-icon>save</mat-icon>
                <span>{{ 'common.saving' | translate }}</span>
                <mat-spinner class="saving-spinner" [diameter]="20"></mat-spinner>
            </ng-template>

            <ng-template #notSaving>
                <mat-icon>save</mat-icon>
                <span>{{ 'common.save' | translate }}</span>
            </ng-template>

            <button data-test="B-Speichern" mat-flat-button
                    color="accent"
                    [disabled]="(settingsFacade.isUpdating$ | async)"
                    (click)="$event.stopPropagation();save()">
                <ng-container *ngIf="(settingsFacade.isUpdating$ | async); then saving else notSaving"></ng-container>
            </button>

        </div>

        <mat-divider></mat-divider>

        <div class="nav-columns-wrapper p-16">

            <div class="nav-column nav-column--left">
                <div class="nav-column__header" fxLayoutAlign="space-between center">
                    <h2>{{ 'userSettings.navigation.currentNav' | translate }}</h2>
                    <div class="button-group">
                        <button mat-stroked-button
                                color="accent"
                                [matTooltip]="'userSettings.navigation.editGroupNamesTooltip' | translate"
                                (click)="itemTitlesEditable = !itemTitlesEditable">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-stroked-button
                                [attr.aria-label]="'common.actions' | translate"
                                [matTooltip]="'userSettings.navigation.moreOptionsTooltip' | translate"
                                [matMenuTriggerFor]="moreMenu"
                                (click)="$event.stopPropagation();">
                            <mat-icon>expand_more</mat-icon>
                        </button>

                        <mat-menu #moreMenu="matMenu">
                            <button mat-menu-item
                                    (click)="addNewNode(ListItemType.Collapsable)">
                                {{ 'userSettings.navigation.addCollapsibleMenu' | translate }}
                            </button>
                        </mat-menu>
                    </div>
                </div>

                <div class="nav-column__scroll" cdkScrollable>
                    <div id="currentNavigationDragDropList"
                         cdkDropList
                         dragAndDropManager
                         [cdkDropListData]="navigation"
                         (cdkDropListDropped)="onDragDrop$.next($event)"
                         class="item-root">

                        <ng-container *ngFor="let item of navigation">
                            <list-item [item]="item"
                                       [itemTitlesEditable]="itemTitlesEditable"
                                       [onDragDrop$]="onDragDrop$"></list-item>
                        </ng-container>

                    </div>
                </div>
            </div>

            <div class="nav-column nav-column--right">

                <div class="nav-column__header" fxLayoutAlign="space-between center">
                    <h2>{{ 'userSettings.navigation.unusedElements' | translate }}</h2>
                </div>

                <div class="nav-column__scroll" cdkScrollable>
                    <div cdkDropList
                         dragAndDropManager
                         [cdkDropListData]="availableNavigationItems"
                         [cdkDropListSortingDisabled]="true"
                         (cdkDropListDropped)="onDragDrop$.next($event)"
                         class="item-root">

                        <ng-container *ngIf="!availableNavigationItems?.length">
                            <u2b-message noMargin="true">
                                <header>{{ 'userSettings.navigation.emptyHeader' | translate }}</header>
                                <p>{{ 'userSettings.navigation.emptyUnusedBody' | translate }}</p>
                            </u2b-message>
                        </ng-container>

                        <ng-container *ngFor="let item of availableNavigationItems">
                            <list-item [item]="item"
                                       [itemTitlesEditable]="itemTitlesEditable"
                                       [onDragDrop$]="onDragDrop$"></list-item>
                        </ng-container>

                    </div>

                    <div fxLayoutAlign="space-between center" class="nav-column__subheader">
                        <h2>{{ 'userSettings.navigation.notAvailableElements' | translate }}</h2>
                    </div>

                    <div class="item-root">

                        <ng-container *ngIf="!notAvailableNavigationItems?.length">
                            <u2b-message noMargin="true">
                                <header>{{ 'userSettings.navigation.emptyHeader' | translate }}</header>
                                <p>{{ 'userSettings.navigation.emptyUnavailableBody' | translate }}</p>
                            </u2b-message>
                        </ng-container>

                        <ng-container *ngFor="let item of notAvailableNavigationItems">
                            <list-item [item]="item"
                                       [itemTitlesEditable]="itemTitlesEditable"
                                       [itemDraggable]="false"></list-item>
                        </ng-container>

                    </div>
                </div>

            </div>
        </div>

    </div>

</div>
